import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpeg';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero */}
      <div className="about-hero">
        <div className="about-hero-bg" />
        <div className="container">
          <span className="section-label" style={{ color: 'rgba(255,255,255,0.5)' }}>Our Story</span>
          <h1 className="about-hero-title">Pioneers in<br /><span>Rice Mill Machinery</span></h1>
          <p className="about-hero-sub">Three decades of engineering excellence from the heart of Hyderabad.</p>
        </div>
      </div>

      {/* Main story */}
      <section className="about-story">
        <div className="container">
          <div className="about-story-grid">
            <div className="about-story-image">
              <div className="asi-frame">
                <img src={logo} alt="Sri Sai Engineerings" className="asi-logo" />
                <div className="asi-tagline">SSE</div>
                <p>Sri Sai Engineerings</p>
                <small>MFG. Modern Rice Mills</small>
              </div>
              <div className="asi-badge">
                <span className="asi-badge-num">30+</span>
                <span>Years in Business</span>
              </div>
            </div>
            <div className="about-story-text">
              <span className="section-label">Who We Are</span>
              <h2 className="section-title">Built on <span style={{ color: 'var(--green-bright)' }}>Expertise</span></h2>
              <p>
                From more than three decades, Sri Sai Engineerings has been the pioneer in manufacturing
                superior quality Modern Rice Mill Machinery, making the rice milling more profitable.
                In our R & D Department, the designs have been made and developed under the supervision of
                experienced, efficient technical staff to ensure high quality Rice.
              </p>
              <p>
                We have brought the modern technology in the field of polishing, shelling, grading etc.
                We also undertake complete Engineering Consultancy and provide Services on Turkey basis
                for Rice Millers — from initial planning to full commissioning.
              </p>
              <p>
                Located in Uppal, Hyderabad, we serve clients across India with our state-of-the-art
                computerized designs and engineering expertise. Our commitment is to give promising
                quality, services, support and development to every rice miller we work with.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pillars */}
      <section className="about-pillars">
        <div className="container">
          <div className="section-header">
            <span className="section-label">What Drives Us</span>
            <h2 className="section-title">Our Core <span style={{ color: 'var(--green-bright)' }}>Pillars</span></h2>
          </div>
          <div className="pillars-grid">
            {[
              {
                num: '01',
                title: 'Specialization',
                color: 'var(--green-bright)',
                desc: 'We have brought the modern technology in the field of polishing, shelling, grading etc. and also undertake complete Engineering Consultancy and provide Services on Turkey basis for Rice Millers.',
              },
              {
                num: '02',
                title: 'Facilities',
                color: 'var(--red-primary)',
                desc: 'We are having up-to-date computerized designs and engineering experts to give promising quality, services, support and development to our clients and partners.',
              },
              {
                num: '03',
                title: 'Infrastructure',
                color: '#f5a623',
                desc: 'We have an extensive infrastructure and continuously engaged in improving quality and up-gradation of technology to ensure improved satisfaction to our clients.',
              },
              {
                num: '04',
                title: 'Innovation',
                color: '#7b1fa2',
                desc: 'Our R&D department continuously develops new designs under experienced technical supervision, ensuring each machine delivers maximum performance and longevity.',
              },
            ].map((pillar, i) => (
              <div className="pillar-card" key={i}>
                <div className="pillar-num" style={{ color: pillar.color }}>{pillar.num}</div>
                <div className="pillar-line" style={{ background: pillar.color }} />
                <h3 className="pillar-title">{pillar.title}</h3>
                <p className="pillar-desc">{pillar.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="about-timeline">
        <div className="timeline-bg" />
        <div className="container">
          <div className="section-header light">
            <span className="section-label" style={{ color: 'rgba(255,255,255,0.4)' }}>Our Journey</span>
            <h2 className="section-title" style={{ color: 'white' }}>Milestones of <span style={{ color: 'var(--gold)' }}>Growth</span></h2>
          </div>
          <div className="timeline">
            {[
              { year: '1995', label: 'Foundation', desc: 'Sri Sai Engineerings established in Uppal, Hyderabad with a vision to modernize rice milling in India.' },
              { year: '2005+', label: 'Expansion', desc: 'Expanded product range to cover full rice milling workflow — from cleaning to polishing and grading.' },
              { year: '2010+', label: 'Innovation', desc: 'Launched R&D department for continuous improvement and computerized design capabilities.' },
              { year: '2015+', label: 'Scale-Up', desc: 'Served 500+ rice mills across India, earned trust with Turkey-key project delivery.' },
              { year: 'Today', label: 'Excellence', desc: '30+ years strong. Continuous refinement. Expanding to new markets with proven machinery.' },
            ].map((item, i) => (
              <div className="timeline-item" key={i}>
                <div className="tl-year">{item.year}</div>
                <div className="tl-dot" />
                <div className="tl-content">
                  <h4>{item.label}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Info Block */}
      <section className="about-contact-block">
        <div className="container">
          <div className="acb-inner">
            <div>
              <h3>Visit Our Factory</h3>
              <p>D.No.1-43 Opp: Rajya Lakshmi Theatre, Uppal, Hyderabad – 500 039</p>
              <p style={{ marginTop: 12 }}>
                {/* 📞 040-27206045 &nbsp;|&nbsp; 65792799<br /> */}
                📱 9848027990<br />
                ✉️ srisaiengs@gmail.com
              </p>
            </div>
            <div className="acb-actions">
              <Link to="/contact" className="acb-btn-primary">Send an Enquiry</Link>
              <Link to="/products" className="acb-btn-secondary">View Products</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
